import { Route, Routes } from 'react-router-dom'
import AuthLayout from '../components/AuthLayout'
import MainLayout from '../components/MainLayout'
import AttitudeSets from '../pages/AttitudeSets'
import Dashboard from '../pages/Dashboard'
import DataOverview from '../pages/DataOverview'
import DomainSets from '../pages/DomainSets'
import EditProject from '../pages/EditProject'
import ErrorPage from '../pages/Error'
import ExternalCase from '../pages/ExternalCase'
import Geometries from '../pages/Geometries'
import Login from '../pages/Login'
import MAVAero from '../pages/MAVAero'
import MAVAeroDocs from '../pages/MAVAeroDocs'
import MAVAeroWebLauncher from '../pages/MAVAeroWebLauncher'
import MethodologySets from '../pages/MethodologySets'
import NewProject from '../pages/NewProject'
import PressureTapImport from '../pages/PressureTapImport'
import PlatformDocs from '../pages/PlatformDocs'
import Profile from '../pages/Profile'
import ProjectConfigs from '../pages/ProjectConfigs'
import Projects from '../pages/Projects'
import RescaleQueue from '../pages/RescaleQueue'
import SimulationSets from '../pages/SimulationSet'
import SolveCountCompliance from '../pages/SolveCountCompliance'
import Submission from '../pages/Submission'
import SubmissionCase from '../pages/SubmissionCase'
import Submissions from '../pages/Submissions'
import SystemMessages from '../pages/SystemMessages'
import AdminTaskManagement from '../pages/AdminTaskManagement'
import StorageTest from '../pages/StorageTest'
import TyreSets from '../pages/TyreSets'
import Users from '../pages/Users'
import Vehicles from '../pages/Vehicles'
import Workflows from '../pages/Workflows'
import WorkflowTemplates from '../pages/WorkflowTemplates'
import NotFound from './NotFound'
import RequireAuth from './RequireAuth'
import routes from './routes'

const Routing = () => {
  return (
    <Routes>
      <Route path="/auth" element={<AuthLayout />} errorElement={<ErrorPage />}>
        <Route path={routes.Login.relativePath} element={<Login />} />
      </Route>
      <Route path={routes.Home.relativePath} element={<MainLayout />} errorElement={<ErrorPage />}>
        <Route index element={<RequireAuth element={<Vehicles />} />} />
        <Route
          path={routes.Vehicles.relativePath}
          element={<RequireAuth element={<Vehicles />} />}
        />
        <Route
          path={routes.Dashboard.relativePath}
          element={<RequireAuth element={<Dashboard />} />}
        />
        <Route
          path={routes.Projects.relativePath}
          element={<RequireAuth element={<Projects />} />}
        />
        <Route
          path={routes.DataOverview.relativePath}
          element={<RequireAuth element={<DataOverview />} />}
        />
        <Route path={routes.Profile.relativePath} element={<RequireAuth element={<Profile />} />} />
        <Route
          path={routes.MethodologySets.relativePath}
          element={<RequireAuth element={<MethodologySets />} />}
        />
        <Route
          path={routes.ProjectConfigs.relativePath}
          element={<RequireAuth element={<ProjectConfigs />} />}
        />
        <Route
          path={routes.Workflows.relativePath}
          element={<RequireAuth element={<Workflows />} />}
        />
        <Route
          path={routes.TyreSets.relativePath}
          element={<RequireAuth element={<TyreSets />} />}
        />
        <Route
          path={routes.DomainSets.relativePath}
          element={<RequireAuth element={<DomainSets />} />}
        />
        <Route
          path={routes.SimulationSets.relativePath}
          element={<RequireAuth element={<SimulationSets />} />}
        />
        <Route
          path={routes.AttitudeSets.relativePath}
          element={<RequireAuth element={<AttitudeSets />} />}
        />
        <Route
          path={routes.Geometries.relativePath}
          element={<RequireAuth element={<Geometries />} />}
        />
        <Route
          path={routes.NewProject.relativePath}
          element={<RequireAuth element={<NewProject />} />}
        />
        <Route
          path={routes.EditProject.relativePath}
          element={<RequireAuth element={<EditProject />} />}
        />
        <Route
          path={routes.Submissions.relativePath}
          element={<RequireAuth element={<Submissions />} />}
        />
        <Route
          path={routes.Submission.relativePath}
          element={<RequireAuth element={<Submission />} />}
        />
        <Route
          path={routes.SubmissionCase.relativePath}
          element={<RequireAuth element={<SubmissionCase />} />}
        />
        <Route
          path={routes.WorkflowTemplates.relativePath}
          element={<RequireAuth element={<WorkflowTemplates />} />}
        />
        <Route
          path={routes.RescaleQueue.relativePath}
          element={<RequireAuth element={<RescaleQueue />} />}
        />
        <Route
          path={routes.ExternalCase.relativePath}
          element={<RequireAuth element={<ExternalCase />} />}
        />
        <Route path={routes.Users.relativePath} element={<RequireAuth element={<Users />} />} />
        <Route
          path={routes.SystemMessages.relativePath}
          element={<RequireAuth element={<SystemMessages />} />}
        />
        <Route
          path={routes.AdminTaskManagement.relativePath}
          element={<RequireAuth element={<AdminTaskManagement />} />}
        />
        <Route
          path={routes.StorageTest.relativePath}
          element={<RequireAuth element={<StorageTest />} />}
        />
        <Route path={routes.MAVAero.relativePath} element={<RequireAuth element={<MAVAero />} />} />
        <Route
          path={routes.MAVAeroDocs.relativePath}
          element={<RequireAuth element={<MAVAeroDocs />} />}
        />
        <Route
          path={routes.MAVAeroWebLauncher.relativePath}
          element={<RequireAuth element={<MAVAeroWebLauncher />} />}
        />
        <Route
          path={routes.PlatformDocs.relativePath}
          element={<RequireAuth element={<PlatformDocs />} />}
        />
        <Route
          path={routes.PressureTapImport.relativePath}
          element={<RequireAuth element={<PressureTapImport />} />}
        />
        <Route
          path={routes.SolveCountCompliance.relativePath}
          element={<RequireAuth element={<SolveCountCompliance />} />}
        />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default Routing
